module.exports = __webpack_public_path__ + "img/icon-print.d7e170f2.svg";